module.exports = __webpack_public_path__ + "img/card-2.0a7ca8a9.svg";